import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetCvrQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { CvrResponse } from "../../../services/ActionReports/ActionReportAPI.types";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";

export const defaultCvrActionReportData = (): CvrResponse => {
  return {
    resultCount: 0,
    period: "",
    results: [],
  };
};

export const FetchCvrActionReportData = (period: string, skipRequest = false) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetCvrQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      Locale: storedLocale(),
    },
    {
      skip: skipRequest,
    },
  );

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [cvrActionReportData, setCvrActionReportData] = useState<CvrResponse>(defaultCvrActionReportData());

  useEffect(() => {
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setCvrActionReportData(payloadData);
    }
  }, [isFetching, period, isError, payloadData, isLoadingWatchlist]);

  return { isLoading, cvrActionReportData, errorStatus, refetch };
};
